/* Ampolis clone kit — scoped to .sp sections. Keep this file name neutral. */
(function () {
  'use strict';

  var BRAND = '#1B2C4E';          /* competitor primary (navy) */

  /* ---------- scroll target: the offer / bundle tiers ---------- */
  function offerEl() {
    return document.getElementById('sp-offer')
      || document.querySelector('.lumin-product-block-qty-break')
      || document.querySelector('[class*="quantity-break"]')
      || document.querySelector('.product-form__submit, .lumin-submit');
  }
  function toOffer(e) {
    var t = offerEl();
    if (!t) return;
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
  }
  window.spToOffer = toOffer;

  /* ---------- every CTA inside a cloned section goes to the offer ---------- */
  function wireCtas() {
    document.querySelectorAll('.sp a[href], .sp button:not([data-sp-skip])').forEach(function (el) {
      if (el.dataset.spWired) return;
      /* never hijack the page's own controls */
      /* never hijack the page's own controls - carousel arrows are buttons too */
      if (el.closest('details, summary, .sp-no-wire')) return;
      if (el.closest('[class*="__arrow"], [class*="arrow"], [class*="__dot"], [class*="carousel"]')) return;
      if (el.hasAttribute('data-zing-prev') || el.hasAttribute('data-zing-next')) return;
      if (el.tagName === 'A') {
        var h = el.getAttribute('href') || '';
        if (h.charAt(0) === '#' && h !== '#') return;        /* real in-page anchor */
        if (/^(mailto:|tel:)/i.test(h)) return;
      }
      el.dataset.spWired = '1';
      el.addEventListener('click', toOffer);
    });
  }

  /* ---------- sticky CTA: shown whenever the offer is off-screen ---------- */
  /* The sticky must not appear while the offer or its Add-to-cart is still on
     screen. #sp-offer is only a 1px anchor ABOVE the tiers, so gate on the end
     of the buy area instead: the Add-to-cart button, else the last tier. */
  function gateEl() {
    var atc = document.querySelector('.product-form__submit, .lumin-submit, button[name="add"]');
    if (atc) return atc;
    var tiers = document.querySelectorAll('.lumin-product-block-qty-break');
    if (tiers.length) return tiers[tiers.length - 1];
    return offerEl();
  }

  function sticky() {
    var bar = document.getElementById('sp-sticky');
    if (!bar) return;
    function tick() {
      var t = gateEl(), show = false;
      if (t) {
        /* hidden at the top, and hidden while the offer / Add-to-cart is still
           visible - it only appears once they have scrolled fully past it. */
        show = t.getBoundingClientRect().bottom < 0;
      }
      /* never cover the cart drawer or its checkout button */
      if (document.querySelector('cart-drawer.active, .cart-drawer.active, .drawer.active, body.overflow-hidden')) show = false;
      bar.style.visibility = show ? 'visible' : 'hidden';
      bar.style.opacity = show ? '1' : '0';
      bar.style.pointerEvents = show ? 'auto' : 'none';
    }
    tick();
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    setInterval(tick, 500);
  }

  /* ---------- brand colour on the buy controls ----------
     the theme paints these from an ID-level !important rule, which outranks any
     stylesheet rule we can add; inline !important is the only thing that wins. */
  function paintButtons() {
    document.querySelectorAll(
      '.product-form__submit, .lumin-submit, .sticky-atc-button,' +
      ' .shopify-payment-button__button, .cart__checkout-button, button[name="checkout"]'
    ).forEach(function (b) {
      b.style.setProperty('background', BRAND, 'important');
      b.style.setProperty('background-image', 'none', 'important');
      b.style.setProperty('border-color', BRAND, 'important');
      b.style.setProperty('color', '#ffffff', 'important');
      b.style.setProperty('--product-accent', BRAND, 'important');
      b.style.setProperty('--product-accent-contrast', '#ffffff', 'important');
      b.querySelectorAll('*').forEach(function (k) {
        k.style.setProperty('color', '#ffffff', 'important');
      });
    });
  }

  /* ---------- anything the clone left at opacity:0 must still be visible ---------- */
  function reveals() {
    document.querySelectorAll('.sp [class*="animate--"], .sp .scroll-trigger, .sp .fade-out').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }


  /* ---------- review carousel (.trv) — the export dropped its script ----------
     The source moves .trv__track with translate3d, but a transform on that element
     is ignored here (even inline + !important), so the viewport is scrolled instead:
     .trv__viewport is overflow-x:hidden, and scrollLeft still works on it. */
  function carousels() {
    document.querySelectorAll('.sp .trv').forEach(function (root) {
      if (root.dataset.spCar) return;
      root.dataset.spCar = '1';
      var view = root.querySelector('.trv__viewport');
      var track = root.querySelector('.trv__track');
      var prev = root.querySelector('.trv__arrow--prev');
      var next = root.querySelector('.trv__arrow--next');
      if (!view || !track) return;
      track.style.transform = 'none';

      function step() {
        var card = track.querySelector('.trv__card');
        if (!card) return view.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return Math.round(card.getBoundingClientRect().width + gap);
      }
      function max() { return Math.max(0, view.scrollWidth - view.clientWidth); }
      function sync() {
        if (prev) prev.disabled = view.scrollLeft <= 2;
        if (next) next.disabled = view.scrollLeft >= max() - 2;
      }
      function go(dir) {
        var target = Math.min(Math.max(view.scrollLeft + dir * step(), 0), max());
        try { view.scrollTo({ left: target, behavior: 'smooth' }); }
        catch (e) { view.scrollLeft = target; }
        /* the smooth scroll is ignored in some embedded frames — land it anyway */
        setTimeout(function () { if (Math.abs(view.scrollLeft - target) > 4) view.scrollLeft = target; sync(); }, 400);
      }
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });
      /* the cards are a fixed 4:5 box with object-fit:cover, so an image that is
         not ~4:5 gets its sides cropped — and the testimonial text is baked into
         these images, so the words get cut. Letterbox those instead, using the
         image's own bottom colour so the fill is invisible. */
      function fitImages() {
        track.querySelectorAll('.trv__img').forEach(function (img) {
          if (img.dataset.spFit) return;
          if (!img.naturalWidth) return;                 /* not decoded yet - try again later */
          var box = img.getBoundingClientRect();
          if (!box.width || !box.height) return;         /* not laid out yet */
          img.dataset.spFit = '1';
          var natural = img.naturalWidth / img.naturalHeight;
          var frame = box.width / box.height;
          if (Math.abs(natural - frame) / frame <= 0.03) return;   /* close enough to cover */
          img.style.setProperty('object-fit', 'contain', 'important');
          try {
            var cv = document.createElement('canvas');
            cv.width = 1; cv.height = 1;
            cv.getContext('2d').drawImage(img, 2, img.naturalHeight - 3, 1, 1, 0, 0, 1, 1);
            var d = cv.getContext('2d').getImageData(0, 0, 1, 1).data;
            img.style.setProperty('background', 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')', 'important');
          } catch (e) {
            img.style.setProperty('background', '#142B4A', 'important');
          }
        });
      }
      track.querySelectorAll('.trv__img').forEach(function (img) {
        img.loading = 'eager';
        img.addEventListener('load', fitImages, { once: true });
      });
      [0, 400, 1200, 2500].forEach(function (t) { setTimeout(fitImages, t); });
      view.addEventListener('scroll', fitImages, { passive: true });
      window.addEventListener('resize', fitImages);

      view.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function init() {
    paintButtons();
    wireCtas();
    carousels();
    reveals();
    sticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(paintButtons).observe(document.documentElement, { childList: true, subtree: true });
})();
